/**
 * @(#)2019/7/11.
 * Paaword，输入密码内容
 * @author 许许
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import { Input } from "antd";
import Basics from "./Basics";
import { cloneDeep } from "../../utils";
import { YxComponent, Connection } from "../YxComponent";
import { get } from "../../utils";
import { l } from "../../config/language";
import { IpasswordPropTypes } from "./IpropType/passwordPropType";
/*
 *-----------------------密码输入框参数-------------------------------------------
 * @param isVisibilityToggle {bool} 是否显示切换按钮，默认为true
 * @param strength {string} 密码强度类型，lv1\lv2\lv3,默认为lv1
 * @param isContrastId {string}  是否需要对比的密码输入框id，用于对比两次密码是否一致
 * @param callback {function}  输入回调，返回密码的强度 weak/middle/strong   弱，中，强
 * @param lenInterval {array}  密码长度区间
 *
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */

//默认props
let defaul = () => {
  return {
    isVisibilityToggle: true,
    strength: "lv1", // null/lv1/lv2/lv3/every 密码强度低/中/高,为null则没有校验，默认为最弱校验
    isContrastId: null,
    rules: {},
    inputParam: {},
    children: <Input.Password />, //子节点
    lenInterval: [],
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class Password extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {
      // weakPsw: /^(?:\d+|[a-zA-Z]+|[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+)$/,
      middlePsw:
        /^(?![a-zA-z]+$)(?!\d+$)(?![`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$)[a-zA-Z\d`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$/,
      strongPsw:
        /^(?![a-zA-z]+$)(?!\d+$)(?![`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$)(?![a-zA-z\d]+$)(?![a-zA-z`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$)(?![\d`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$)[a-zA-Z\d`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$/,
      value: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    //输入框值发生变化后，调用getStrength
    if (nextProps.form.getFieldValue(this.props.id) !== this.state.value) {
      this.getStrength();
    }
  }
  compareToFirstPassword(tmpProps) {
    if (tmpProps.isContrastId) {
      tmpProps.rules.confirmPassword = {
        validator: (rule, value, callback) => {
          const { form } = this.props;
          if (value && value !== form.getFieldValue(tmpProps.isContrastId)) {
            callback(l("PassWord.em", this));
          } else {
            callback();
          }
        },
      };
    }
    return tmpProps;
  }

  getLenInterval(tmpProps) {
    let { lenInterval } = tmpProps;
    if (get(tmpProps, "strength", null) !== "every") {
      tmpProps.rules.lenInterval = {
        validator: (rule, value, callback) => {
          if (
            (value && value.length < lenInterval[0]) ||
            value.length > lenInterval[1]
          ) {
            callback(
              l("PassWord.rm", this, { l1: lenInterval[0], l2: lenInterval[1] })
            );
          } else {
            callback();
          }
        },
      };
    }
    return tmpProps;
  }

  //获取密码强度
  getStrength() {
    const { form } = this.props;
    const { weakPsw, middlePsw, strongPsw } = this.state;
    let value = form.getFieldValue(this.props.id);
    this.setState({ value });
    if (value) {
      let pswStrength = 0;
      value = String(value);
      if (value.match(strongPsw)) {
        pswStrength = "lv3";
      } else if (value.match(middlePsw)) {
        pswStrength = "lv2";
      } else {
        pswStrength = "lv1";
      }
      if (this.props.callback) {
        this.props.callback(pswStrength);
      }
    }
  }

  //合并默认参数和外部参数
  productionHtml() {
    let tmpProps = { ...this.props };
    //清空规则，避免引用对象指向同一地址
    // tmpProps.rules = tmpProps.rules;
    const { weakPsw, middlePsw, strongPsw } = this.state;
    //是否显示切换按钮
    tmpProps.inputParam.visibilityToggle = tmpProps.isVisibilityToggle;
    if (get(tmpProps, "strength", null) !== "every") {
      tmpProps.rules.strength = {
        //密码强度为弱，密码为数字、字母、特殊符号的任意的一种组合
        lv1: {
          pattern: weakPsw,
          message: l("PassWord.lv1", this),
        },
        //密码强度为中，密码为数字、字母、特殊符号的任意的两种组合
        lv2: {
          pattern: middlePsw,
          message: l("PassWord.lv2", this),
        },
        //密码强度为强，密码为数字、字母、特殊符号三种组合
        lv3: {
          pattern: strongPsw,
          message: l("PassWord.lv3", this),
        },
      }[tmpProps.strength];
    }
    tmpProps = this.getLenInterval(tmpProps);
    tmpProps = this.compareToFirstPassword(tmpProps);

    let classParam = {
      yx_yxPassword_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxPassword_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    //合并默认参数和外部参数
    return this.productionHtml();
  }
}
Password.propTypes = IpasswordPropTypes;
Password.defaultProps = defaul();
export default Password;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Password.js